import React from "react";

const ProductTitleVideo = (props) => {
  const { title, video } = props;
  
  return (
    <>
      <div className="product-details__top">
        <div className="product-details__top__left">
          <h3 className="product-details__name" style={{borderBottom: '1px solid var(--boskery-border-color, #EBE3D9)', paddingBottom: '10px', marginBottom: '10px'}}>{title}</h3>
        </div>
      </div><br/>
      <div className="product-details__review">
        {/* <div className="boskery-ratings">
          <span className="icon-star"></span>
          <span className="icon-star"></span>
          <span className="icon-star"></span>
          <span className="icon-star"></span>
          <span className="icon-star"></span>
        </div> */}
      </div>
    </>
  );
};

export default ProductTitleVideo;
